import React, { PropTypes } from 'react';
import assign from 'object.assign';
import PureComponent from 'components/PureComponent';

class WaveLink extends PureComponent {
  static propTypes = {
    href: PropTypes.string.isRequired,
    color: PropTypes.string,
    element: PropTypes.string.isRequired
  };

  static defaultProps = {
    element: 'a'
  };

  render() {
    require('./WaveLink.styl');

    const style = assign({}, this.props.style || {}, {
      color: this.props.color
    });

    return React.createElement(
      this.props.element,
      assign({}, this.props, {
        className: 'WaveLink',
        style: style,
        href: this.props.href
      }),
      this.props.children
    );
  }
}

export default WaveLink;



// WEBPACK FOOTER //
// ./src/components/WaveLink/WaveLink.js